import styled from "styled-components";
import { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { pricelistGetById } from "../../../../services/warehouses/pricelist-get-by-id";
import {
  dateFormating,
  getMagazineTypeFromEnum,
  getServiceFromEnum,
  getUnitFromEnum,
} from "../../../operator-views/operator-orders-offering/helpers";
import { LoadingBackDrop } from "../../../../components/loader";
import { StyledButton } from "../../../../components/Button/button";
import { StyledTable } from "../../../../components/table/styled-table";
import { theme } from "../../../../helpers/theme";
import { PriceList } from "../../../../services/warehouses/pricelist-get-by-id/types";
import { GoBackButton } from "../../../../components/GoBackButton";

const WarehousesPricelist = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const columns: GridColDef[] = [
    {
      field: "usluga_magazynu",
      headerName: "Usługa",
      width: 250,
      sortable: false,
      filterable: false,
      hideable: false,
    },
    {
      field: "rodzaj_oferty",
      headerName: "Rodzaj oferty",
      width: 200,
    },
    {
      field: "nazwa",
      headerName: "Nazwa",
      width: 300,
    },

    {
      field: "jednostka",
      headerName: "Jednostka",
      width: 150,
    },
    {
      field: "nazwa_na_fakture",
      headerName: "Nazwa na fakturę",
      width: 200,
    },
    {
      field: "wazna_od",
      headerName: "Ważna od",
      width: 200,
    },
    {
      field: "wazna_do",
      headerName: "Ważna do",
      width: 200,
    },
  ];

  const [pricelist, setPricelist] = useState<PriceList[]>([]);

  const body = {
    id_magazyn: String(id),
  };

  const PricelistGetById = useQuery(
    ["Pricelist"],
    () => pricelistGetById(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(data) {
        setPricelist(data.data.payload.cennik_uslug);
      },
    }
  );

  const rows = pricelist.map((r: PriceList) => ({
    id: r.id_cennik,
    usluga_magazynu: getServiceFromEnum(r.usluga_magazynu),
    rodzaj_oferty: getMagazineTypeFromEnum(r.rodzaj_oferty),
    nazwa: r.nazwa,
    jednostka: getUnitFromEnum(r.jednostka_rozliczenia),
    nazwa_na_fakture: r.nazwa_na_fakture,
    wazna_od: dateFormating(r.wazny_od),
    wazna_do: dateFormating(r.wazny_do),
  }));

  if (PricelistGetById.isLoading || PricelistGetById.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }

  return (
    <PricelistContainer>
      <ViewNavigation>
        <Redirect>
          <GoBackButton description={"Powrót"} />
        </Redirect>
      </ViewNavigation>
      <StyledTable
        // getRowId={(row) => row?.id}
        rows={rows}
        columns={columns}
        autoPageSize
      />
    </PricelistContainer>
  );
};

export default WarehousesPricelist;

const PricelistContainer = styled.div`
  height: 80vh;

  display: flex;
  flex-direction: column;
  margin-left: 0;
  padding-right: 0;

  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
const ViewNavigation = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 340px) {
    flex-direction: column;
  }
`;

const Redirect = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
`;
